/* Keep Shopify's variant selection and gallery intact; only filter media by Olist SKU. */
(function () {
  'use strict';

  var skuPattern = /^Scarlat SKU (\S+) foto \d+ \|/i;
  var archivedPattern = /^Scarlat foto anterior \|/i;

  function ownerSku(slide) {
    var match = (slide.dataset.scarlatMediaAlt || '').match(skuPattern);
    return match ? match[1] : null;
  }

  function applyGallery(productInfo, sku, featuredMediaId) {
    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery || !sku || typeof gallery.setActiveMedia !== 'function') return;
    var slides = Array.from(gallery.querySelectorAll('.product__media-list > li[data-media-id]'));
    if (!slides.some(function (slide) { return ownerSku(slide) || archivedPattern.test(slide.dataset.scarlatMediaAlt || ''); })) return;

    var currentSlides = slides.filter(function (slide) { return !archivedPattern.test(slide.dataset.scarlatMediaAlt || ''); });
    var forSku = currentSlides.filter(function (slide) { return ownerSku(slide) === sku; });
    var general = currentSlides.filter(function (slide) { return !ownerSku(slide); });
    var visible = forSku.length ? forSku : general;
    if (!visible.length) {
      visible = slides.filter(function (slide) { return slide.dataset.mediaId.endsWith('-' + featuredMediaId); });
    }
    if (!visible.length) return;

    var visibleIds = new Set(visible.map(function (slide) { return slide.dataset.mediaId; }));
    var visibleMediaIds = new Set(visible.map(function (slide) { return slide.dataset.mediaId.split('-').pop(); }));
    slides.forEach(function (slide) {
      slide.classList.toggle('scarlat-variant-media-hidden', !visibleIds.has(slide.dataset.mediaId));
    });
    gallery.querySelectorAll('.thumbnail-list > li[data-target]').forEach(function (thumbnail) {
      thumbnail.classList.toggle('scarlat-variant-media-hidden', !visibleIds.has(thumbnail.dataset.target));
    });

    var modal = document.getElementById('ProductModal-' + productInfo.dataset.section);
    if (modal) {
      modal.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach(function (item) {
        item.classList.toggle('scarlat-variant-media-hidden', !visibleMediaIds.has(item.dataset.mediaId));
      });
    }

    gallery.classList.toggle('scarlat-variant-gallery--single', visible.length === 1);
    var active = visible.find(function (slide) {
      return slide.dataset.mediaId.endsWith('-' + featuredMediaId);
    }) || visible[0];
    gallery.setActiveMedia(active.dataset.mediaId, false);

    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');
    viewer && viewer.resetPages && viewer.resetPages();
    thumbnails && thumbnails.resetPages && thumbnails.resetPages();
    if (viewer) {
      var currentCounter = viewer.querySelector('.slider-counter--current');
      var totalCounter = viewer.querySelector('.slider-counter--total');
      if (currentCounter) currentCounter.textContent = '1';
      if (totalCounter) totalCounter.textContent = String(visible.length);
    }
    if (viewer && visible.length === 1) {
      viewer.totalPages = 1;
      if (viewer.prevButton) viewer.prevButton.disabled = true;
      if (viewer.nextButton) viewer.nextButton.disabled = true;
    }
    productInfo.dataset.scarlatCurrentSku = sku;
    productInfo.dataset.scarlatFeaturedMediaId = featuredMediaId || '';
  }

  function init() {
    customElements.whenDefined('media-gallery').then(function () {
      document.querySelectorAll('product-info[data-scarlat-current-sku]').forEach(function (productInfo) {
        applyGallery(productInfo, productInfo.dataset.scarlatCurrentSku, productInfo.dataset.scarlatFeaturedMediaId);
      });
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.variant || !data.sectionId) return;
        var productInfo = document.getElementById('MainProduct-' + data.sectionId);
        if (!productInfo) return;
        customElements.whenDefined('media-gallery').then(function () {
          window.requestAnimationFrame(function () {
            applyGallery(productInfo, data.variant.sku, data.variant.featured_media && data.variant.featured_media.id);
          });
        });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
